import React from 'react';
import { Box } from '@mui/material';

import { v2Colors } from '../../design/theme';
import CheckoutRadioIndicator from './CheckoutRadioIndicator';

/**
 * @param {{
 *   selected?: boolean,
 *   disabled?: boolean,
 *   onClick?: () => void,
 *   children: React.ReactNode,
 *   showRadio?: boolean,
 *   sx?: object,
 * }} props
 */
export default function CheckoutSelectionCard({
  selected = false,
  disabled = false,
  onClick,
  children,
  showRadio = true,
  sx,
}) {
  return (
    <Box
      component="button"
      type="button"
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      sx={[
        {
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.25,
          width: '100%',
          m: 0,
          p: 1.5,
          textAlign: 'left',
          borderRadius: 2,
          border: '1px solid',
          borderColor: selected ? v2Colors.primary : v2Colors.borderMuted,
          bgcolor: selected ? v2Colors.selectedFill : v2Colors.white,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.65 : 1,
          fontFamily: 'inherit',
          transition: 'border-color 0.15s, background-color 0.15s',
          '&:hover': disabled
            ? {}
            : {
                borderColor: v2Colors.primary,
                bgcolor: selected ? v2Colors.selectedFill : v2Colors.white,
              },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {showRadio ? <CheckoutRadioIndicator selected={selected} /> : null}
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    </Box>
  );
}
